module.exports = "https://coursera_assets.s3.amazonaws.com/images/6867e27c5503b49765acab0162310496.png";